import domReady from "@wordpress/dom-ready";
import { createRoot } from "@wordpress/element";
import SettingsApp from "./SettingsApp";
import "./style.scss";
domReady(() => {
    const root = createRoot(document.getElementById("wpb-pmqb-settings-app"));
    root.render(<SettingsApp />);
});
